export const filtersFix = (node) => {
    const nextOrphans = [];
    const parentNode = node.closest('[data-filter-type]');
    let nextOrphan = parentNode.nextElementSibling;

    do {
        if (
            !nextOrphan.getAttribute('data-filter-type') &&
                nextOrphans.length < 2
        ) {
            nextOrphans.push(nextOrphan);
        }
        // eslint-disable-next-line no-cond-assign
    } while (nextOrphan = nextOrphan.nextElementSibling);

    node.insertAdjacentHTML(
        'beforeend',
        '<div class="form-group-container"></div>'
    );

    nextOrphans.forEach((orphan) => {
        node
            .querySelector('.form-group-container')
            .insertAdjacentHTML('beforeend', `
<div class="form-group-field">${orphan.outerHTML}</div>
`);
        orphan.remove();
    });
};

export const filtersHide = () => {
    const networkFilter = document.querySelector('#fieldset-network_multiselect');

    if (networkFilter) {
        // const networkChoices = networkFilter.querySelectorAll('.filterChoice');
        // const networkSelectableOptions = [...networkChoices].filter(option => option.classList.contains('selectableOption'), 0);
        // networkFilter.classList.toggle('hide', networkSelectableOptions.length <= 1);
    }

    const refurbOption = document.querySelector('.filterChoice > [data-title="Refurbished"]');

    if (refurbOption) {
        const input = refurbOption.querySelector('#filter_is_refurbished');
        if (input && input.disabled) {
            refurbOption.classList.add('hide');
        }
    }
};
